import React from "react";
import PageBanner from "../../components/common/PageBanner";
import SectionHeading from "../../components/common/SectionHeading";
import FacilityImageGallery from "../../components/User/Rental/FacilityImageGallery";
import RentalRules from "../../components/User/Rental/RentalRules";
import RentalSchedule from "../../components/User/Rental/RentalSchedule";
import axios from "axios";
import { useState, useEffect } from "react";
const RequestBookBtn = ({ onClick }) => {
  return (
    <>
      <button
        onClick={onClick}
        className="font-subheading m-2 md:my-4 font-medium sm:font-semibold 
             text-white px-4 sm:px-6 py-3 sm:py-4 text-sm sm:text-base 
             rounded-md bg-primaryBtnColor transition-all duration-200 
             hover:bg-primaryBtnHoverColor active:scale-95 
             leading-[20.15px] tracking-[0.02em] text-center align-middle 
             select-none"
      >
        Request to Book
      </button>
    </>
  );
};
const Rental = () => {
  const [sectionHeadingData, setSectionHeadingData] = useState({});
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bannerData, setBannerData] = useState({});
  const [bannerloading, setBannerloading] = useState(false);

  const getBannerData = () => {
    setBannerloading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/page-banner/get-banner/rental`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setBannerData(response.data);
        setBannerloading(false);
      })
      .catch((error) => {
        console.log(error);
        setBannerloading(false);
      });
  };

  useEffect(() => {
    getBannerData();
  }, []);

  const getData = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rental/get-rental-data`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        const rentalData = response?.data?.rental;
        setSectionHeadingData(rentalData);
        setRules(rentalData?.rentalRules || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);
  const handleOnClick = () => {
    const element = document.getElementById("schedule-rental-section");
    const yOffset = -75;
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };
  return (
    <div>
      {bannerloading ? (
        <BannerSkeleton />
      ) : (
        <PageBanner
          title={bannerData.title}
          subtitle={bannerData.subtitle}
          background={bannerData.bgImage}
        />
      )}
      {loading ? (
        <div className="px-6 py-12 space-y-4">
          <SkeletonBox width="w-3/4" height="h-10" />
          <SkeletonBox width="w-full" height="h-6" />
          <SkeletonBox width="w-5/6" height="h-6" />
        </div>
      ) : (
        <SectionHeading
          title={sectionHeadingData?.heading}
          subtitle={sectionHeadingData?.subHeading}
          actions={<RequestBookBtn onClick={handleOnClick} />}
          containerClassName={"py-4 md:py-8 lg:py-12 my-4"}
        />
      )}
      <FacilityImageGallery />
      {loading ? (
        <div className="px-6 py-8 space-y-3">
          {[...Array(6)].map((_, i) => (
            <SkeletonBox key={i} width="w-full" height="h-5" />
          ))}
        </div>
      ) : (
        <RentalRules rules={rules} />
      )}
      <RentalSchedule />
    </div>
  );
};

export default Rental;

const SkeletonBox = ({ width = "w-full", height = "h-6", className = "" }) => {
  return (
    <div
      className={`bg-gray-300/40 animate-pulse rounded-md ${width} ${height} ${className}`}
    ></div>
  );
};
const BannerSkeleton = () => {
  return (
    <div className="relative w-full h-36 sm:h-52 md:h-60 lg:h-80 px-4 md:px-8 lg:px-12 animate-pulse">
      <div className="absolute inset-0 bg-gray-300/50"></div>

      <div className="relative z-10 flex flex-col justify-center h-full">
        <div className="h-8 w-40 bg-gray-400/60 rounded-md mb-4"></div>
        <div className="h-4 w-64 bg-gray-400/50 rounded-md"></div>
      </div>
    </div>
  );
};
